import React from 'react';
import { useRouter } from "next/router";
import { makeStyles, createStyles } from '@material-ui/core/styles';
import {
  Box,
  Chip,
  TableCell,
  TableRow,
  Typography
} from '@material-ui/core';
import LaunchIcon from '@material-ui/icons/Launch';
import { useAuth } from "../util/auth";

const useStyles = makeStyles((theme) =>
  createStyles({
    snippet: {
      fontStyle: 'italic',
      color: 'grey',
      maxWidth: '400px',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
    },
    tagContainer: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    tagChip: {
      margin: theme.spacing(0.5),
    },
    clickableTitle: {
      // 1) Remove 'display: flex; align-items: center;' so it doesn’t
      //    shift baseline alignment compared to the snippet cell.
      cursor: 'pointer',
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
    launchIcon: {
      fontSize: 16,
      verticalAlign: 'middle',
      marginLeft: theme.spacing(0.5),
    },
    cellTopAlign: {
      // 2) Force all table cells to align at the top
      verticalAlign: 'top',
    },
  })
);

interface StoryItemProps {
  storyId: string;
  tags: string[];
  title: string;
  text?: string;
  setSignupRequired: (val: boolean) => void;
  setPayMeActive: (val: boolean) => void;
}

export default function StoryItem({
  storyId,
  tags,
  title,
  text,
  setSignupRequired,
  setPayMeActive
}: StoryItemProps) {
  const classes = useStyles();
  const router = useRouter();
  const auth = useAuth();

  function snip(fullText: string | undefined) {
    if (!fullText) return '';
    const firstChars = fullText.substring(0, 80);
    const lastSpace = firstChars.lastIndexOf(' ');
    return firstChars.substring(0, lastSpace) + '...';
  }

  const textSnippet = snip(text);

  async function chooseStoryHandler() {
    // Navigate to the detail page, or handle your own custom logic
    router.push('/story/' + storyId);
  }

  return (
    <TableRow hover>
      {/* Title Cell */}
      <TableCell
        onClick={chooseStoryHandler}
        className={`${classes.clickableTitle} ${classes.cellTopAlign}`}
      >
        <Typography variant="body1" style={{ fontWeight: 600 }}>
          {title}
          <LaunchIcon className={classes.launchIcon} />
        </Typography>
      </TableCell>

      {/* Snippet Cell */}
      <TableCell className={`${classes.snippet} ${classes.cellTopAlign}`}>
        {textSnippet}
      </TableCell>

      {/* Tags Cell */}
      <TableCell className={classes.cellTopAlign}>
        <Box className={classes.tagContainer}>
          {tags.map((tag) => (
            <Chip key={tag} label={tag} size="small" className={classes.tagChip} />
          ))}
        </Box>
      </TableCell>
    </TableRow>
  );
}
